import { Component, EventEmitter, Inject, Injector, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationDataService } from '../../../notification-data.service';

@Component({
  selector: 'app-verify-contact-dialog',
  templateUrl: './verify-contact-dialog.component.html',
  styleUrls: ['./verify-contact-dialog.component.scss']
})
export class VerifyContactDialogComponent {

  public contactType: 'email'|'mobile';
  public title = 'VERIFY_CONTACT.TITLE';

  @Output() output = new EventEmitter<any>();
  
  constructor(
    protected _injector: Injector,
    public dialogRef: MatDialogRef<VerifyContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.contactType = this.data.contactType;
  }

  closeAfterSubmit(event){
    this.output.emit(true);
    this.dialogRef.close()
    this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("VERIFY_CONTACT.SUCCESS_MESSAGE"));
  }

  closeAfterCancel(event){
    this.output.emit(false);
    this.dialogRef.close()
  }
}